import React from "react";

// Slow editorial marquee (duplicated track for seamless loop).
export const Marquee = ({ items, className = "", separator = "✦" }) => {
  const track = [...items, ...items];
  return (
    <div className={`relative flex overflow-x-hidden overflow-y-visible ${className}`}>
      <div className="flex shrink-0 animate-marquee whitespace-nowrap will-change-transform py-3">
        {track.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="mx-8 font-heading text-4xl md:text-6xl font-light tracking-tight leading-[1.3] pb-1">{t}</span>
            <span className="text-ochre text-2xl md:text-3xl">{separator}</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
